import type { StackProps } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledIconWrapper,
  StyledIconBackground,
  StyledIcon,
  StyledBenefitHeadline,
  StyledBenefitDescription,
  StyledBenefitsWrapper,
  SingleBenefitWrapper,
} from './styles';
import { whenRustForWebData } from './WhenRustForWeb.data';

export const WhenRustForWeb = ({ ...props }: StackProps) => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            When to Choose Rust for Web Development
          </StyledFirstTitle>

          <StyledSecondTitle variant="regular_500">
            Rust is Perfect When You Need:
          </StyledSecondTitle>
        </StyledTwoTitles>

        <StyledBenefitsWrapper>
          {whenRustForWebData.map((el, index) => {
            return (
              <SingleBenefitWrapper key={index}>
                <StyledIconWrapper>
                  <StyledIconBackground>
                    <StyledIcon src={el.img} alt={el.title} />
                  </StyledIconBackground>
                </StyledIconWrapper>
                <StyledBenefitHeadline variant="strong_500">
                  {el.title}
                </StyledBenefitHeadline>
                <StyledBenefitDescription variant="regular_400">
                  {el.description}
                </StyledBenefitDescription>
              </SingleBenefitWrapper>
            );
          })}
        </StyledBenefitsWrapper>
      </StyledStack>
    </Section>
  );
};
